import { formatDisplayDate } from '@/utils/date';

interface FeedbackReadStateProps {
  readAt: Date | null;
}

export function FeedbackReadState({ readAt }: FeedbackReadStateProps) {
  if (readAt === null) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary">
        <span className="size-1.5 shrink-0 rounded-full bg-primary" aria-hidden />
        Unread
      </span>
    );
  }
  return (
    <span className="text-xs whitespace-nowrap text-muted-foreground">
      Read {formatDisplayDate(readAt)}
    </span>
  );
}
